import { ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY } from './orquestadorAccess';

export function getStoredOrquestadorAccessToken(storage = window.localStorage) {
  return storage.getItem(ORQUESTADOR_ACCESS_TOKEN_STORAGE_KEY);
}

export function buildOrquestadorAuthorizedHeaders(init = {}, storage = window.localStorage) {
  const headers = new Headers(init.headers || {});
  const accessToken = getStoredOrquestadorAccessToken(storage);

  if (accessToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return headers;
}

export function fetchWithOrquestadorAuthorization(input, init = {}, storage = window.localStorage) {
  return fetch(input, {
    ...init,
    headers: buildOrquestadorAuthorizedHeaders(init, storage),
  });
}
